import type { GetCustomFieldDefinitionsResponse } from '@vy/api-definition';
import { GetCustomFieldDefinitionsResponseSchema } from '@vy/api-definition';
import type { QueryClient, UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import { queryKeys } from '../../../services/query-key/query-keys';

async function customFieldDefinitionsQuery(): Promise<GetCustomFieldDefinitionsResponse> {
  const api = getPrivateApi();
  const response = await api.getCustomFieldDefinitions();

  return GetCustomFieldDefinitionsResponseSchema.parse(response);
}

export function useCustomFieldDefinitions(options?: UseQueryOptions<GetCustomFieldDefinitionsResponse>) {
  return useQuery({
    queryKey: [queryKeys.customFieldDefinitions()],
    queryFn: customFieldDefinitionsQuery,
    ...options,
  });
}

export async function prefetchCustomFieldDefinitions(queryClient: QueryClient) {
  return queryClient.prefetchQuery([queryKeys.customFieldDefinitions()], customFieldDefinitionsQuery);
}
